import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import { isEmpty } from "BaseFunctions";
import Button from "react-bootstrap-button-loader";
//var LineChart = require("react-chartjs").Line;
import {
  ComposedChart,
  Line,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
  PieChart,
  Pie,
  Cell,
  Sector,
  Label,
  LabelList,
} from "recharts";
import {
  scaleOrdinal,
  schemeCategory10,
  schemeCategory20,
  schemeCategory20b,
  schemeCategory20c,
} from "d3-scale";
import { isTablet, DATE_FORMAT } from "Constants";
import LocaleStrings from "Languages";

var randomColor = require("randomcolor");

class DashboardDevice extends Component {
  constructor(props) {
    super(props);
    // debugger;
    var randomColors = this.generateColors(); //[...scaleOrdinal(schemeCategory20).range(),...scaleOrdinal(schemeCategory20b).range(),...scaleOrdinal(schemeCategory20c).range()];

    this.state = {
      colors: randomColors,
      device: "ios",
      hitstype: "date",
      data: [],
      innerLoader: props.newprop,
    };

    this.oniosSelection = this.oniosSelection.bind(this);
    this.onAndroidSelection = this.onAndroidSelection.bind(this);
    this.onWebSelection = this.onWebSelection.bind(this);
  }

  generateColors = () => {
    var randomColors = []; //[...scaleOrdinal(schemeCategory20).range(),...scaleOrdinal(schemeCategory20b).range(),...scaleOrdinal(schemeCategory20c).range()];
    for (var i = 0; i < 200; i++) {
      randomColors.push(randomColor());
    }
    randomColors = [
      ...randomColors,
      ...randomColor({ hue: "red", count: 50 }),
      ...randomColor({ hue: "orange", count: 50 }),
      ...randomColor({ hue: "blue", count: 50 }),
      ...randomColor({ hue: "green", count: 50 }),
      randomColor({ hue: "yellow", count: 50 }),
      ...randomColor({ hue: "purple", count: 50 }),
      ...randomColor({ hue: "pink", count: 50 }),
      ...randomColor({ luminosity: "dark", count: 50 }),
    ];
    randomColors = _.shuffle(randomColors);
    randomColors = _.shuffle(randomColors);
    randomColors = _.shuffle(randomColors);

    return randomColors;
  };

  componentWillReceiveProps(nextprops) {
    if (this.state.innerLoader != nextprops.newprop) {
      this.setState({ innerLoader: !nextprops.newprop });

      this.state.hitstype == "weekly"
        ? this.arrangeDataWeekly(nextprops.devices)
        : this.state.hitstype == "monthly"
        ? this.arrangeDataMonthly(nextprops.devices)
        : this.arrangeDataDateWise(nextprops.devices, nextprops.dateProps);
    }
  }

  componentDidMount() {
    setTimeout(() => {
      // this.arrangeDataWeekly(this.props.devices);
      this.arrangeDataDateWise(this.props.devices, this.props.dateProps);
    }, 300);
  }

  componentWillReceiveProps(nextprops) {
    if (this.state.innerLoader != nextprops.newprop) {
      this.setState({ innerLoader: !nextprops.newprop });

      this.state.hitstype == "weekly"
        ? this.arrangeDataWeekly(nextprops.devices)
        : this.state.hitstype == "monthly"
        ? this.arrangeDataMonthly(nextprops.devices)
        : this.arrangeDataDateWise(nextprops.devices, nextprops.dateProps);
    }
  }

  oniosSelection() {
    this.setState({ ...this.state, device: "ios" });
  }

  onAndroidSelection() {
    this.setState({ ...this.state, device: "android" });
  }

  onWebSelection() {
    this.setState({ ...this.state, device: "web" });
  }

  arrangeDataMonthly = (data) => {
    var months = [
      { name: "JAN", ios: 0, android: 0, web: 0 },
      { name: "FEB", ios: 0, android: 0, web: 0 },
      { name: "MAR", ios: 0, android: 0, web: 0 },
      { name: "APR", ios: 0, android: 0, web: 0 },
      { name: "MAY", ios: 0, android: 0, web: 0 },
      { name: "JUN", ios: 0, android: 0, web: 0 },
      { name: "JUL", ios: 0, android: 0, web: 0 },
      { name: "AUG", ios: 0, android: 0, web: 0 },
      { name: "SEP", ios: 0, android: 0, web: 0 },
      { name: "OCT", ios: 0, android: 0, web: 0 },
      { name: "NOV", ios: 0, android: 0, web: 0 },
      { name: "DEC", ios: 0, android: 0, web: 0 },
    ];
    var monthsWithData = [];
    var curYear = moment().year();
    months.map((month, monthindex) => {
      var iOSmonthHitsCount = 0;
      var androidmonthHitsCount = 0;
      var webmonthHitsCount = 0;

      var iOS_set = [];
      var android_set = [];
      var web_set = [];

      data.map((value, index) => {
        var dateYear = moment(value.timestamp).year();
        if (curYear === dateYear) {
          //If data belongs to same year
          var monthDay = moment(value.timestamp).month();
          if (monthDay - 1 === monthindex) {
            if (value.platform === "iOS") {
              iOSmonthHitsCount++;
              iOS_set.push(value);
            } else if (value.platform === "android") {
              androidmonthHitsCount++;
              android_set.push(value);
            } else if (value.platform === "web") {
              webmonthHitsCount++;
              web_set.push(value);
            }
          }
        }
      });
      monthsWithData.push({
        ...month,
        ios: iOSmonthHitsCount,
        android: androidmonthHitsCount,
        web: webmonthHitsCount,
        iosset: iOS_set,
        androidset: android_set,
        webset: web_set,
      });
    });

    this.setState({ data: monthsWithData });
    this.calculateOtherDetailsForMonths(monthsWithData);
  };

  calculateOtherDetailsForMonths = (monthsWithData) => {
    // debugger;
    var totaliOSThisMonth = 0;
    var totaliOSLastMonth = 0;

    var totalAndroidThisMonth = 0;
    var totalAndroidLastMonth = 0;

    var totalWebThisMonth = 0;
    var totalWebLastMonth = 0;

    var changeAndroid = "same";
    var monthDay = moment().month();
    monthDay = monthDay - 1;
    if (monthDay !== 0)
      totalAndroidLastMonth = monthsWithData[monthDay - 1].android;
    totalAndroidThisMonth = monthsWithData[monthDay].android;

    var percentageAndroid = 0;
    if (totalAndroidThisMonth > totalAndroidLastMonth) {
      percentageAndroid =
        (totalAndroidLastMonth / totalAndroidThisMonth) * 100.0;
      changeAndroid = "higher";
    } else if (totalAndroidThisMonth < totalAndroidLastMonth) {
      percentageAndroid =
        (totalAndroidThisMonth / totalAndroidLastMonth) * 100.0;
      changeAndroid = "lower";
    }

    percentageAndroid = Math.floor(percentageAndroid);

    var changeiOS = "same";
    var monthDay = moment().month();
    monthDay = monthDay - 1;
    if (monthDay !== 0) totaliOSLastMonth = monthsWithData[monthDay - 1].ios;
    totaliOSThisMonth = monthsWithData[monthDay].ios;

    var percentageiOS = 0;
    if (totaliOSThisMonth > totaliOSLastMonth) {
      percentageiOS = (totaliOSLastMonth / totaliOSThisMonth) * 100.0;
      changeiOS = "higher";
    } else if (totaliOSThisMonth < totaliOSLastMonth) {
      percentageiOS = (totaliOSThisMonth / totaliOSLastMonth) * 100.0;
      changeiOS = "lower";
    }

    percentageiOS = Math.floor(percentageiOS);

    // Web
    var changeWEB = "same";
    var monthDay = moment().month();
    monthDay = monthDay - 1;
    if (monthDay !== 0) totalWebLastMonth = monthsWithData[monthDay - 1].ios;
    totalWebThisMonth = monthsWithData[monthDay].ios;

    var percentageWEB = 0;
    if (totalWebThisMonth > totalWebLastMonth) {
      percentageWEB = (totalWebLastMonth / totalWebThisMonth) * 100.0;
      changeWEB = "higher";
    } else if (totalWebThisMonth < totalWebLastMonth) {
      percentageWEB = (totalWebThisMonth / totalWebLastMonth) * 100.0;
      changeWEB = "lower";
    }

    percentageWEB = Math.floor(percentageWEB);

    this.setState({
      totaliostoday: totaliOSThisMonth,
      percentageiOS,
      changeiOS,
      totalandroidtoday: totalAndroidThisMonth,
      percentageAndroid,
      changeAndroid,
      totalwebtoday: totalWebThisMonth,
      percentageWEB,
      changeWEB,
    });
  };

  arrangeDataDateWise = (data, dateObj) => {
    // console.log("data :- ", data);
    // console.log("dateObj :- ", dateObj);
    let workingDate = [];
    let selectedDate = [];
    let start = new Date(dateObj.from);
    let end = new Date(dateObj.to);
    let loop = new Date(start);
    while (loop <= end) {
      // console.log(loop);
      // console.log(moment(loop).format(DATE_FORMAT));
      workingDate.push(moment(loop).format(DATE_FORMAT));
      let month = loop.getMonth() + 1;
      selectedDate.push({
        workingdate: moment(loop).format(DATE_FORMAT),
        name: loop.getDate() + "/" + month,
        ios: 0,
        android: 0,
        web: 0,
      });

      let newDate = loop.setDate(loop.getDate() + 1);
      loop = new Date(newDate);
    }

    var dateWithData = [];
    selectedDate.map((obj, index) => {
      let date = obj.workingdate;
      // console.log("date :- ", date);
      var iOSmonthHitsCount = 0;
      var androidmonthHitsCount = 0;
      var webmonthHitsCount = 0;
      var iOS_set = [];
      var android_set = [];
      var web_set = [];

      data.map((value, i) => {
        if (moment(value.timestamp).format(DATE_FORMAT) == date) {
          if (value.platform === "iOS") {
            iOSmonthHitsCount++;
            iOS_set.push(value);
          } else if (value.platform === "android") {
            androidmonthHitsCount++;
            android_set.push(value);
          } else if (value.platform === "web") {
            webmonthHitsCount++;
            web_set.push(value);
          }
        }
      });

      dateWithData.push({
        ...obj,
        ios: iOSmonthHitsCount,
        android: androidmonthHitsCount,
        web: webmonthHitsCount,
        iosset: iOS_set,
        androidset: android_set,
        webset: web_set,
      });
    });

    // console.log("dateWithData :- ", dateWithData);
    this.setState({ data: dateWithData });
    this.calculateOtherDetailsForDate(dateWithData);
  };

  calculateOtherDetailsForDate = (dateWithData) => {
    // debugger;
    var totaliOSToday = 0;
    var totaliOSYesterday = 0;

    var totalAndroidToday = 0;
    var totalAndroidYesterday = 0;

    var totalWebToday = 0;
    var totalWebYesterday = 0;

    // Android
    var changeAndroid = "same";
    var toDay = moment().format(DATE_FORMAT);
    var lastDate = _.last(dateWithData);
    if (toDay > lastDate) {
      totalAndroidYesterday = _.last(dateWithData).android;
      let match = _.filter(dateWithData, (o) => {
        return o.workingdate == toDay;
      });
      totalAndroidToday = match.length > 0 ? dateWithData[0].android : 0;
    }

    var percentageAndroid = 0;
    if (totalAndroidToday > totalAndroidYesterday) {
      percentageAndroid = (totalAndroidYesterday / totalAndroidToday) * 100.0;
      changeAndroid = "higher";
    } else if (totalAndroidToday < totalAndroidYesterday) {
      percentageAndroid = (totalAndroidToday / totalAndroidYesterday) * 100.0;
      changeAndroid = "lower";
    }
    percentageAndroid = Math.floor(percentageAndroid);

    // iOS
    var changeiOS = "same";
    var toDay = moment().format(DATE_FORMAT);
    var lastDate = _.last(dateWithData);
    if (toDay > lastDate) {
      totaliOSYesterday = _.last(dateWithData).ios;
      let match = _.filter(dateWithData, (o) => {
        return o.workingdate == toDay;
      });
      totaliOSToday = match.length > 0 ? dateWithData[0].ios : 0;
    }

    var percentageiOS = 0;
    if (totaliOSToday > totaliOSYesterday) {
      percentageiOS = (totaliOSYesterday / totaliOSToday) * 100.0;
      changeiOS = "higher";
    } else if (totaliOSToday < totaliOSYesterday) {
      percentageiOS = (totaliOSToday / totaliOSYesterday) * 100.0;
      changeiOS = "lower";
    }
    percentageiOS = Math.floor(percentageiOS);

    // Web
    var changeWEB = "same";
    var toDay = moment().format(DATE_FORMAT);
    var lastDate = _.last(dateWithData);
    if (toDay > lastDate) {
      totalWebYesterday = _.last(dateWithData).web;
      let match = _.filter(dateWithData, (o) => {
        return o.workingdate == toDay;
      });
      totalWebToday = match.length > 0 ? dateWithData[0].web : 0;
    }

    var percentageWEB = 0;
    if (totalWebToday > totalWebYesterday) {
      percentageWEB = (totalWebYesterday / totalWebToday) * 100.0;
      changeWEB = "higher";
    } else if (totalWebToday < totalWebYesterday) {
      percentageWEB = (totalWebToday / totalWebYesterday) * 100.0;
      changeWEB = "lower";
    }
    percentageWEB = Math.floor(percentageWEB);

    this.setState({
      totaliostoday: totaliOSToday,
      percentageiOS,
      changeiOS,
      totalandroidtoday: totalAndroidToday,
      percentageAndroid,
      changeAndroid,
      totalwebtoday: totalWebToday,
      percentageWEB,
      changeWEB,
    });
  };

  arrangeDataWeekly = (data) => {
    var device = this.state.device;

    var weeks = [
      { name: "MON", ios: 0, android: 0, web: 0 },
      { name: "TUE", ios: 0, android: 0, web: 0 },
      { name: "WED", ios: 0, android: 0, web: 0 },
      { name: "THU", ios: 0, android: 0, web: 0 },
      { name: "FRI", ios: 0, android: 0, web: 0 },
      { name: "SAT", ios: 0, android: 0, web: 0 },
      { name: "SUN", ios: 0, android: 0, web: 0 },
    ];

    var weeksWithData = [];
    weeks.map((week, weekindex) => {
      var weekiOSHitsCount = 0;
      var weekAndroidHitsCount = 0;
      var weekWebHitsCount = 0;

      var iOS_set = [];
      var android_set = [];
      var web_set = [];

      data.map((value, index) => {
        var weekDay = moment(value.timestamp).isoWeekday();
        if (value.platform === "iOS") {
          if (weekDay === 0 && weekindex === 6) {
            //Sunday
            weekiOSHitsCount++;
            iOS_set.push(value);
          } else if (weekDay - 1 === weekindex) {
            weekiOSHitsCount++;
            iOS_set.push(value);
          }
        } else if (value.platform === "android") {
          if (weekDay === 0 && weekindex === 6) {
            //Sunday
            weekAndroidHitsCount++;
            android_set.push(value);
          } else if (weekDay - 1 === weekindex) {
            weekAndroidHitsCount++;
            android_set.push(value);
          }
        } else if (value.platform === "web") {
          if (weekDay === 0 && weekindex === 6) {
            //Sunday
            weekWebHitsCount++;
            web_set.push(value);
          } else if (weekDay - 1 === weekindex) {
            weekWebHitsCount++;
            web_set.push(value);
          }
        }
      });
      weeksWithData.push({
        ...week,
        ios: weekiOSHitsCount,
        android: weekAndroidHitsCount,
        web: weekWebHitsCount,
        iosset: iOS_set,
        androidset: android_set,
        webset: web_set,
      });
    });
    this.setState({ data: weeksWithData });
    this.calculateOtherDetailsForWeek(weeksWithData);
  };

  calculateOtherDetailsForWeek = (data) => {
    var totaliOSToday = 0;
    var totaliOSYesterday = 0;

    var totalAndroidToday = 0;
    var totalAndroidYesterday = 0;

    var totalWebToday = 0;
    var totalWebYesterday = 0;

    var weekDay = moment().isoWeekday();
    if (weekDay === 0) {
      //Sunday
      totaliOSYesterday = data[5].ios;
      totaliOSToday = data[6].ios;

      totalAndroidYesterday = data[5].android;
      totalAndroidToday = data[6].android;

      totalWebYesterday = data[5].web;
      totalWebToday = data[6].web;
    } else {
      weekDay = weekDay - 1;
      if (weekDay !== 0) {
        totaliOSYesterday = data[weekDay - 1].ios;
        totalAndroidYesterday = data[weekDay - 1].android;
        totalWebYesterday = data[weekDay - 1].android;
      }
      totaliOSToday = data[weekDay].ios;
      totalAndroidToday = data[weekDay].android;
      totalWebToday = data[weekDay].android;
    }

    var changeAndroid = "same";
    var percentageAndroid = 0;
    if (totalAndroidToday > totalAndroidYesterday) {
      percentageAndroid = (totalAndroidYesterday / totalAndroidToday) * 100.0;
      changeAndroid = "higher";
    } else if (totalAndroidToday < totalAndroidYesterday) {
      percentageAndroid = (totalAndroidToday / totalAndroidYesterday) * 100.0;
      changeAndroid = "lower";
    }
    percentageAndroid = Math.floor(percentageAndroid);

    var changeiOS = "same";
    var percentageiOS = 0;
    if (totaliOSToday > totaliOSYesterday) {
      percentageiOS = (totaliOSYesterday / totaliOSToday) * 100.0;
      changeiOS = "higher";
    } else if (totaliOSToday < totaliOSYesterday) {
      percentageiOS = (totaliOSToday / totaliOSYesterday) * 100.0;
      changeiOS = "lower";
    }
    percentageiOS = Math.floor(percentageiOS);

    // Web
    var changeWEB = "same";
    var percentageWEB = 0;
    if (totalWebToday > totalWebYesterday) {
      percentageWEB = (totalWebYesterday / totalWebToday) * 100.0;
      changeWEB = "higher";
    } else if (totalWebToday < totalWebYesterday) {
      percentageWEB = (totalWebToday / totalWebYesterday) * 100.0;
      changeWEB = "lower";
    }
    percentageWEB = Math.floor(percentageWEB);

    this.setState({
      totaliostoday: totaliOSToday,
      percentageiOS,
      changeiOS,
      totalandroidtoday: totalAndroidToday,
      percentageAndroid,
      changeAndroid,
      totalwebtoday: totalWebToday,
      percentageWEB,
      changeWEB,
    });
  };

  arrangeDataDateWise = (data, dateObj) => {
    // console.log("data :- ", data);
    // console.log("dateObj :- ", dateObj);
    let workingDate = [];
    let selectedDate = [];
    let start = new Date(dateObj.from);
    let end = new Date(dateObj.to);
    let loop = new Date(start);
    while (loop <= end) {
      // console.log(loop);
      // console.log(moment(loop).format(DATE_FORMAT));
      workingDate.push(moment(loop).format(DATE_FORMAT));
      let month = loop.getMonth() + 1;
      selectedDate.push({
        workingdate: moment(loop).format(DATE_FORMAT),
        name: loop.getDate() + "/" + month,
        ios: 0,
        android: 0,
        web: 0,
      });

      let newDate = loop.setDate(loop.getDate() + 1);
      loop = new Date(newDate);
    }

    var dateWithData = [];
    selectedDate.map((obj, index) => {
      let date = obj.workingdate;
      // console.log("date :- ", date);
      var iOSmonthHitsCount = 0;
      var androidmonthHitsCount = 0;
      var webmonthHitsCount = 0;
      var iOS_set = [];
      var android_set = [];
      var web_set = [];

      data.map((value, i) => {
        if (moment(value.timestamp).format(DATE_FORMAT) == date) {
          if (value.platform === "iOS") {
            iOSmonthHitsCount++;
            iOS_set.push(value);
          } else if (value.platform === "android") {
            androidmonthHitsCount++;
            android_set.push(value);
          } else if (value.platform === "web") {
            webmonthHitsCount++;
            web_set.push(value);
          }
        }
      });

      dateWithData.push({
        ...obj,
        ios: iOSmonthHitsCount,
        android: androidmonthHitsCount,
        web: webmonthHitsCount,
        iosset: iOS_set,
        androidset: android_set,
        webset: web_set,
      });
    });

    // console.log("dateWithData :- ", dateWithData);
    this.setState({ data: dateWithData });
    this.calculateOtherDetailsForDate(dateWithData);
  };

  calculateOtherDetailsForDate = (dateWithData) => {
    // debugger;
    var totaliOSToday = 0;
    var totaliOSYesterday = 0;

    var totalAndroidToday = 0;
    var totalAndroidYesterday = 0;

    var totalWebToday = 0;
    var totalWebYesterday = 0;

    // Android
    var changeAndroid = "same";
    var toDay = moment().format(DATE_FORMAT);
    var lastDate = _.last(dateWithData);
    if (toDay > lastDate) {
      totalAndroidYesterday = _.last(dateWithData).android;
      let match = _.filter(dateWithData, (o) => {
        return o.workingdate == toDay;
      });
      totalAndroidToday = match.length > 0 ? dateWithData[0].android : 0;
    }

    var percentageAndroid = 0;
    if (totalAndroidToday > totalAndroidYesterday) {
      percentageAndroid = (totalAndroidYesterday / totalAndroidToday) * 100.0;
      changeAndroid = "higher";
    } else if (totalAndroidToday < totalAndroidYesterday) {
      percentageAndroid = (totalAndroidToday / totalAndroidYesterday) * 100.0;
      changeAndroid = "lower";
    }
    percentageAndroid = Math.floor(percentageAndroid);

    // iOS
    var changeiOS = "same";
    var toDay = moment().format(DATE_FORMAT);
    var lastDate = _.last(dateWithData);
    if (toDay > lastDate) {
      totaliOSYesterday = _.last(dateWithData).ios;
      let match = _.filter(dateWithData, (o) => {
        return o.workingdate == toDay;
      });
      totaliOSToday = match.length > 0 ? dateWithData[0].ios : 0;
    }

    var percentageiOS = 0;
    if (totaliOSToday > totaliOSYesterday) {
      percentageiOS = (totaliOSYesterday / totaliOSToday) * 100.0;
      changeiOS = "higher";
    } else if (totaliOSToday < totaliOSYesterday) {
      percentageiOS = (totaliOSToday / totaliOSYesterday) * 100.0;
      changeiOS = "lower";
    }
    percentageiOS = Math.floor(percentageiOS);

    // Web
    var changeWEB = "same";
    var toDay = moment().format(DATE_FORMAT);
    var lastDate = _.last(dateWithData);
    if (toDay > lastDate) {
      totalWebYesterday = _.last(dateWithData).web;
      let match = _.filter(dateWithData, (o) => {
        return o.workingdate == toDay;
      });
      totalWebToday = match.length > 0 ? dateWithData[0].web : 0;
    }

    var percentageWEB = 0;
    if (totalWebToday > totalWebYesterday) {
      percentageWEB = (totalWebYesterday / totalWebToday) * 100.0;
      changeWEB = "higher";
    } else if (totalWebToday < totalWebYesterday) {
      percentageWEB = (totalWebToday / totalWebYesterday) * 100.0;
      changeWEB = "lower";
    }
    percentageWEB = Math.floor(percentageWEB);

    this.setState({
      totaliostoday: totaliOSToday,
      percentageiOS,
      changeiOS,
      totalandroidtoday: totalAndroidToday,
      percentageAndroid,
      changeAndroid,
      totalwebtoday: totalWebToday,
      percentageWEB,
      changeWEB,
    });
  };

  onOptionsChange = (e) => {
    var hitstype = e.currentTarget.value;
    this.setState({ hitstype });
    if (hitstype === "weekly") {
      //Weekly
      this.arrangeDataWeekly(this.props.devices);
    } else if (hitstype === "monthly") {
      //Monthly
      this.arrangeDataMonthly(this.props.devices);
    }
  };

  determinePieiOSVersions = (data) => {
    // debugger;
    var versions = [];

    data.map((value, index) => {
      value.iosset.map((device, deviceindex) => {
        versions.push({ model: device.model, version: device.systemversion });
      });
    });

    var totalcount = versions.length;

    var uniques = _.uniqBy(versions, function (elem) {
      return [elem.model, elem.version].join();
    });

    var values = [];

    uniques.map((valueObj, index) => {
      var device = [valueObj.model, valueObj.version].join();
      var count = 0;
      versions.map((versionObj, versionindex) => {
        var version = [versionObj.model, versionObj.version].join();
        if (version === device) {
          count++;
        }
      });
      var percentage = (count / totalcount) * 100;
      percentage = Math.floor(percentage);
      values.push({
        device: device,
        name: `${valueObj.model}(${valueObj.version})-${percentage}%`,
        value: count,
      });
    });

    return { values: values, totalcount: totalcount };
  };

  determinePieAndroidVersions = (data) => {
    // debugger;
    var versions = [];

    data.map((value, index) => {
      value.androidset.map((device, deviceindex) => {
        versions.push({ model: device.model, version: device.systemversion });
      });
    });

    var totalcount = versions.length;

    var uniques = _.uniqBy(versions, function (elem) {
      return [elem.model, elem.version].join();
    });

    var values = [];

    uniques.map((valueObj, index) => {
      var device = [valueObj.model, valueObj.version].join();
      var count = 0;
      versions.map((versionObj, versionindex) => {
        var version = [versionObj.model, versionObj.version].join();
        if (version === device) {
          count++;
        }
      });
      var percentage = (count / totalcount) * 100;
      percentage = Math.floor(percentage);
      values.push({
        device: device,
        name: `${valueObj.model}(${valueObj.version})-${percentage}%`,
        value: count,
      });
    });

    return { values: values, totalcount: totalcount };
  };

  // Web
  determinePieWebVersions = (data) => {
    // debugger;
    var versions = [];

    data.map((value, index) => {
      value.webset.map((device, deviceindex) => {
        versions.push({ model: device.model, version: device.systemversion });
      });
    });

    var totalcount = versions.length;

    var uniques = _.uniqBy(versions, function (elem) {
      return [elem.model, elem.version].join();
    });

    var values = [];

    uniques.map((valueObj, index) => {
      var device = [valueObj.model, valueObj.version].join();
      var count = 0;
      versions.map((versionObj, versionindex) => {
        var version = [versionObj.model, versionObj.version].join();
        if (version === device) {
          count++;
        }
      });
      var percentage = (count / totalcount) * 100;
      percentage = Math.floor(percentage);
      values.push({
        device: device,
        name: `${valueObj.model}(${valueObj.version})-${percentage}%`,
        value: count,
      });
    });

    return { values: values, totalcount: totalcount };
  };

  changeCssForDevice = ({ percentage, change, hitstype }) => {
    var changedesc = "";
    var changeCss = "";

    if (hitstype === "weekly") {
      if (change === "higher") {
        if (percentage === 0)
          changedesc = LocaleStrings.analytics_text_no_install_yesterday;
        else
          changedesc = `+ ${percentage}% ${LocaleStrings.analytics_text_higher_than_yesterday}`;
        changeCss = "hits-arrow-up";
      } else if (change === "lower") {
        if (percentage === 0)
          changedesc = LocaleStrings.analytics_text_no_install_yesterday;
        else
          changedesc = `- ${percentage}% ${LocaleStrings.analytics_text_lower_than_yesterday}`;
        changeCss = "hits-arrow-down";
      }
      if (change === "same") {
        changedesc = LocaleStrings.analytics_text_no_change_from_yesterday;
      }
    } else if (hitstype === "monthly") {
      if (change === "higher") {
        if (percentage === 0)
          changedesc = LocaleStrings.analytics_text_no_install_last_month;
        else
          changedesc = `+ ${percentage}% ${LocaleStrings.analytics_text_higher_than_last_month}`;
        changeCss = "hits-arrow-up";
      } else if (change === "lower") {
        if (percentage === 0)
          changedesc = LocaleStrings.analytics_text_no_install_last_month;
        else
          changedesc = `- ${percentage}% ${LocaleStrings.analytics_text_lower_than_last_month}`;
        changeCss = "hits-arrow-down";
      }
      if (change === "same") {
        changedesc = LocaleStrings.analytics_text_no_change_from_last_month;
      }
    }

    return { changedesc, changeCss };
  };

  render() {
    var {
      totalwebtoday,
      percentageWEB,
      changeWEB,
      totaliostoday,
      percentageiOS,
      changeiOS,
      totalandroidtoday,
      percentageAndroid,
      changeAndroid,
      data,
      device,
      hitstype,
    } = this.state;

    var iOSCount = 0;
    var androidCount = 0;
    var webCount = 0;

    data.map((value, index) => {
      iOSCount = iOSCount + value.iosset.length;
      androidCount = androidCount + value.androidset.length;
      webCount = webCount + value.webset.length;
    });

    var total = iOSCount + androidCount + webCount;

    var percentiOSInstalled =
      total > 0 ? Math.round((iOSCount / total) * 100) : 0;
    var percentAndriodInstalled =
      total > 0 ? Math.round((androidCount / total) * 100) : 0;
    var percentWebInstalled =
      total > 0 ? Math.round((webCount / total) * 100) : 0;

    var colorIndex = 0;

    var androidStyle = "default";
    var webStyle = "default";
    var iosStyle = "primary";

    if (this.state.device === "ios") {
      iosStyle = "primary";
      androidStyle = "default";
      webStyle = "default";
    } else if (this.state.device === "android") {
      iosStyle = "default";
      androidStyle = "primary";
      webStyle = "default";
    } else if (this.state.device === "web") {
      iosStyle = "default";
      androidStyle = "default";
      webStyle = "primary";
    }

    var pieVersion = [];
    var pieGraph = [];
    // var total = 0;

    var changedesc = "";
    var changeCss = "";

    if (this.state.device === "ios") {
      pieVersion = this.determinePieiOSVersions(data);
      total = totaliostoday;
      var desciOS = this.changeCssForDevice({
        percentage: percentageiOS,
        change: changeiOS,
        hitstype,
      });
      changedesc = desciOS.changedesc;
      changeCss = desciOS.changeCss;
    } else if (this.state.device === "android") {
      pieVersion = this.determinePieAndroidVersions(data);
      total = totalandroidtoday;
      var descAndroid = this.changeCssForDevice({
        percentage: percentageAndroid,
        change: changeAndroid,
        hitstype,
      });
      changedesc = descAndroid.changedesc;
      changeCss = descAndroid.changeCss;
    } else if (this.state.device === "web") {
      pieVersion = this.determinePieWebVersions(data);
      total = totalwebtoday;
      var descWeb = this.changeCssForDevice({
        percentage: percentageWEB,
        change: changeWEB,
        hitstype,
      });
      changedesc = descWeb.changedesc;
      changeCss = descWeb.changeCss;
    }
    pieVersion.values = _.orderBy(pieVersion.values, ["value"], ["desc"]); // Order By
    var colClass = "col-md-6 col-xs-12 col-lg-12";

    if (isTablet) colClass = "col-md-12 col-xs-12 col-lg-12";

    return (
      <div className="row">
        <div className={colClass}>
          <div className="panel panel-default dashboard-panel">
            <div
              className="panel-heading dashboard-panel-head"
              style={{ borderColor: "white" }}
            >
              <div className="pull-left text-capitalize dashboard-content-heading">
                {LocaleStrings.analytics_text_app_install}
              </div>
              <div className="pull-right text-capitalize addNewField">
                <ul className="header-buttons">
                  <li>
                    <span className="analytics-chart-right-subheader">
                      {LocaleStrings.as_per_date}
                    </span>
                    {/* <select
                      onChange={this.onOptionsChange}
                      name="hitstype"
                      className="form-control"
                    >
                      <option value="weekly">{LocaleStrings.weekly}</option>
                      <option value="monthly">{LocaleStrings.monthly}</option>
                      <option value="date">{LocaleStrings.as_per_date}</option>
                    </select> */}
                  </li>
                </ul>
              </div>
            </div>
            {!isEmpty(data) ? (
              <div className="panel-body chart-container">
                <div
                  className="device-percentage"
                  style={{ paddingBottom: 20 }}
                >
                  <div className="row">
                    <div className="col-md-12" style={{ color: "#4C5267" }}>
                      <span style={{ fontSize: 24 }}>{total}</span>
                      <span style={{ fontSize: 16 }}>
                        {" "}
                        {LocaleStrings.installs}
                      </span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      <span style={{ fontSize: 18 }}>
                        {percentiOSInstalled}%
                      </span>
                      <span style={{ fontSize: 12 }}> {LocaleStrings.ios}</span>
                    </div>
                    <div className="col-md-3">
                      <span style={{ fontSize: 18 }}>
                        {percentAndriodInstalled}%
                      </span>
                      <span style={{ fontSize: 12 }}>
                        {" "}
                        {LocaleStrings.android}
                      </span>
                    </div>
                    <div className="col-md-3">
                      <span style={{ fontSize: 18 }}>
                        {percentWebInstalled}%
                      </span>
                      <span style={{ fontSize: 12 }}> {LocaleStrings.web}</span>
                    </div>
                  </div>
                </div>
                <ResponsiveContainer>
                  <ComposedChart
                    data={data}
                    margin={{ top: 10, right: 30, left: 0, bottom: 5 }}
                  >
                    <XAxis dataKey="name" />
                    <CartesianGrid strokeDasharray="2 2" />
                    <Tooltip active={true} />
                    <Area
                      type="monotone"
                      dataKey="ios"
                      stroke="#3e9112"
                      fill="#7ec857"
                      fillOpacity="1"
                      tooltip={{ active: false }}
                    />
                    <Line type="monotone" dataKey="ios" stroke="#ff7300" />
                    <Area
                      type="monotone"
                      dataKey="android"
                      stroke="#0e6dd3"
                      fill="#0f80fb"
                      fillOpacity="1"
                      tooltip={{ active: false }}
                    />
                    <Line type="monotone" dataKey="android" stroke="#ff7300" />
                    <Area
                      type="monotone"
                      dataKey="web"
                      stroke="#0e6dd3"
                      fill="#0f80fb"
                      fillOpacity="1"
                      tooltip={{ active: false }}
                    />
                    <Line type="monotone" dataKey="web" stroke="#ff7300" />
                  </ComposedChart>
                </ResponsiveContainer>
              </div>
            ) : (
              <div className="nouser-info">
                <span>{LocaleStrings.analytics_text_no_device_installed}</span>
              </div>
            )}
          </div>
        </div>
        <div className={colClass}>
          <div className="panel panel-default" style={{ overflow: "scroll" }}>
            <div
              className="panel-heading dashboard-panel-head"
              style={{ borderColor: "white" }}
            >
              <p className="text-capitalize dashboard-content-heading">
                {LocaleStrings.analytics_text_device_plateform}{" "}
                <span className="toggle-buttons">
                  <Button
                    bsStyle={iosStyle}
                    className="toggle-left"
                    type="button"
                    onClick={this.oniosSelection}
                  >
                    {LocaleStrings.ios}
                  </Button>
                  <Button
                    bsStyle={androidStyle}
                    className="toggle-center"
                    type="button"
                    onClick={this.onAndroidSelection}
                  >
                    {LocaleStrings.android}
                  </Button>
                  <Button
                    bsStyle={webStyle}
                    className="toggle-right"
                    type="button"
                    onClick={this.onWebSelection}
                  >
                    {LocaleStrings.web}
                  </Button>
                </span>
              </p>
              <div className="device-toggle-buttons"></div>
            </div>
            {!isEmpty(pieVersion.values) ? (
              <div className="panel-body dashboard-device-platform-graph-panel">
                <div className="hitscount" style={{ paddingBottom: 80 }}>
                  <div className="hits">
                    {total}
                    <p className={changeCss}></p>
                  </div>
                  <div className="hitsdesc">{changedesc}</div>
                </div>
                <PieChart width={500} height={220}>
                  <Pie
                    data={pieVersion.values}
                    outerRadius={80}
                    innerRadius={70}
                    dataKey="value"
                    labelLine={false}
                    legendType="circle"
                  >
                    {pieVersion.values.map((entry, index) => (
                      <Cell
                        key={`slice-${index}`}
                        fill={this.state.colors[index]}
                      />
                    ))}
                  </Pie>
                  <Tooltip />
                  <Legend
                    iconSize={5}
                    wrapperStyle={{
                      top: 0,
                      maxHeight: "200px",
                      overflow: "auto",
                      width: "300px",
                      fontSize: 11,
                    }}
                    layout="vertical"
                    verticalAlign="middle"
                    align="left"
                  />
                </PieChart>
              </div>
            ) : (
              <div className="nouser-info">
                <span>{LocaleStrings.analytics_text_no_device_installed}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

{
  /*<LineChart data={data} options={chartOptions} legend={legendOpts} width="550" height="200"/>*/
}

function mapStateToProps(state) {
  return {
    session: state.session,
    dateProps: state.analyticscommondatepropsreducer,
  };
}

export default connect(mapStateToProps, null)(DashboardDevice);
